module.exports = __webpack_public_path__ + "static/img/progress.06f5ef6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/progress.gif
// module id = 5Ik+
// module chunks = 1